module.exports = __webpack_public_path__ + "static/media/icons8-trash.d543d333.svg";